import React from "react";
import "./styles/CryptoApp.css";
import { GameStyleType } from "./Components/types/types";
import Board from "./Components/Board";
import TopBar from "./Components/TopBar";
import TextArea from "./Components/TextArea";
import Helppanel from "./Components/Helppanel";
import { GameProvider } from "./GameContext";
import FullscreenToggle from "./FullscreenToggle";

const AppContent: React.FC<GameStyleType> = ({ words, cryptoKey, random }) => {
  return (
    <div id="crypto-content">
      <div className="crypto-conteiner">
        <div className="crypto-titleGame">
          <div className="crypto-mainsubtitle">Магический квадрат</div>
          <FullscreenToggle />
        </div>
        <div className="crypto-game-wrapper">
          <div className="crypto-Scene">
            <TopBar />
            <Board words={words} cryptoKey={cryptoKey} random={random} />
          </div>
          <TextArea />
        </div>
        <Helppanel />
      </div>
    </div>
  );
};

const App: React.FC<GameStyleType> = (props) => {
  return (
    <GameProvider>
      <AppContent
        words={props.words}
        cryptoKey={props.cryptoKey}
        random={props.random}
      />
    </GameProvider>
  );
};

export default App;
